import ubBanzai from 'ub/control/banzai-features';

const PERCENTAGE_DIVIDER = 100;
const fontSearchThreshold = ubBanzai.getFeatureValue('fontSearchThreshold') / PERCENTAGE_DIVIDER;

export default {
  shouldSort: true,
  tokenize: true,
  threshold: fontSearchThreshold,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "family"
  ]
};



// WEBPACK FOOTER //
// ./src/fonts/font-service/fuse-options.js